import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", code: "00" },
  { to: "/programs", label: "Programs", code: "01" },
  { to: "/products", label: "Products", code: "02" },
  { to: "/services", label: "Services", code: "03" },
  { to: "/about", label: "About", code: "04" },
  { to: "/contact", label: "Contact", code: "05" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 border-b transition-all ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-black/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="ri-container flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="flex items-center"
        >
          <img
            src="/assets/images/gakuen_logo.png"
            alt="Gakuen Technologies"
            className="h-12 md:h-16 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link font-mono text-[11px] uppercase tracking-[0.15em] ${
                  isActive ? "active text-[var(--ri-ink)]" : "text-[var(--ri-muted)] hover:text-[var(--ri-ink)]"
                }`
              }
            >
              <span className="text-[var(--ri-orange)] mr-2">{item.code}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="https://wa.me/918121642833?text=I%20want%20to%20know%20about%20you"
            target="_blank"
            rel="noreferrer"
            className="btn-ghost text-[11px]"
          >
            WhatsApp Us
          </a>
          <Link
            to="/contact"
            data-testid="navbar-cta-book"
            className="btn-primary text-[11px]"
          >
            Book Program <ArrowUpRight size={14} />
          </Link>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="navbar-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden w-10 h-10 grid place-items-center border border-[var(--ri-ink)]"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-black/10 bg-white">
          <div className="ri-container py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center justify-between font-display text-2xl ${
                    isActive ? "text-[var(--ri-orange)]" : "text-[var(--ri-ink)]"
                  }`
                }
              >
                <span>
                  <span className="text-[var(--ri-orange)] font-mono text-xs mr-3">
                    {item.code}
                  </span>
                  {item.label}
                </span>
                <ArrowUpRight size={18} />
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-cta-book"
              className="btn-primary mt-2 justify-center"
            >
              Book RoboInsci program <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
